// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1CbFA","title":"InfoRow_title__3MQ5T"};